const m = {
  maxWidth: "128rem"
}, r = {
  xxs: {
    gutter: "0.8rem",
    margin: "1.6rem",
    maxWidth: `${35.9 * 0.625}rem`,
    // 35.9 * 0.625 = 22.4375rem
    minWidth: "0rem"
  },
  xs: {
    gutter: "0.8rem",
    margin: "1.6rem",
    maxWidth: `${37.4 * 0.625}rem`,
    // 37.4 * 0.625 = 23.375rem
    minWidth: `${36 * 0.625}rem`
    // 36 * 0.625 = 22.5rem
  },
  s: {
    gutter: "0.8rem",
    margin: "1.6rem",
    maxWidth: `${76.7 * 0.625}rem`,
    // 76.7 * 0.625 = 47.9375rem
    minWidth: `${37.5 * 0.625}rem`
    // 37.5 * 0.625 = 23.4375rem
  },
  m: {
    gutter: "1.2rem",
    margin: "2.4rem",
    maxWidth: `${102.3 * 0.625}rem`,
    // 102.3 * 0.625 = 63.9375rem
    minWidth: `${76.8 * 0.625}rem`
    // 76.8 * 0.625 = 48rem
  },
  l: {
    gutter: "1.2rem",
    margin: "2.4rem",
    maxWidth: `${143.9 * 0.625}rem`,
    // 143.9 * 0.625 = 89.9375rem
    minWidth: `${102.4 * 0.625}rem`
    // 102.4 * 0.625 = 64rem
  },
  xl: {
    gutter: "1.6rem",
    margin: "8rem",
    maxWidth: `${191.9 * 0.625}rem`,
    // 191.9 * 0.625 = 119.9375rem
    minWidth: `${144 * 0.625}rem`
    // 144 * 0.625 = 90rem
  },
  xxl: {
    gutter: "1.6rem",
    margin: "8rem",
    maxWidth: "",
    minWidth: `${192 * 0.625}rem`
    // 192 * 0.625 = 120rem
  }
};
export {
  r as gridConfig,
  m as gridContainerConfig
};
